export default __webpack_public_path__ + "static/media/result-life-span.1fa124da.svg";